import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-[#0A2540] to-[#1E3A5F] text-white py-6">
        <div className="container mx-auto px-4">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="text-white hover:bg-white/10 mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Button>
          <h1 className="text-4xl font-bold">Datenschutzerklärung</h1>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8 prose prose-lg max-w-none">
          <h2>Verantwortlicher</h2>
          <p><strong>Seeschloss-GbR (See Schlosshotel am Kellersee)</strong></p>
          <p>
            Sitz: Lauritz Maßmannstr. 11, 23774 Heiligenhafen, Deutschland
          </p>
          <p>
            Angaben zu den vertretungsberechtigten Gesellschaftern sowie weitere Kontaktdaten entnehmen Sie bitte 
            unserem <a href="/impressum">Impressum</a>.
          </p>
          <p>
            Datenschutz-Kontakt:{' '}
            <a href="mailto:buchung@seeschlosshotel-kellersee.com">buchung@seeschlosshotel-kellersee.com</a>
          </p>
          <p>
            (Ein Datenschutzbeauftragter ist mangels Verpflichtung nach Art. 37 DSGVO nicht benannt.)
          </p>

          <h2>Rechtsgrundlagen, Zwecke, Pflicht zur Bereitstellung</h2>
          <p>
            Wir verarbeiten personenbezogene Daten zur Bereitstellung dieser Website, zur Bearbeitung von 
            Kontakt- und Buchungsanfragen, zur Reservierung/Vertragsdurchführung und zur Erfüllung gesetzlicher Pflichten.
          </p>
          <ul>
            <li>Art. 6 Abs. 1 lit. b DSGVO (Vertrag/Anbahnung)</li>
            <li>Art. 6 Abs. 1 lit. c DSGVO (gesetzliche Pflichten, z. B. Melde-, Aufbewahrungs-, steuer- und handelsrechtliche Pflichten)</li>
            <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen: sichere, effiziente Bereitstellung/Abwicklung, IT-Sicherheit, Abwehr von Missbrauch)</li>
            <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), sofern wir diese im Einzelfall einholen</li>
          </ul>
          <p>
            Ohne die für Buchung/Check-in erforderlichen Angaben ist ein Vertragsabschluss bzw. die Beherbergung nicht möglich.
          </p>

          <h2>Hosting & Server-Logfiles</h2>
          <p>
            Beim Aufruf unserer Seiten verarbeitet der Webserver automatisiert Protokolldaten (u. a. IP-Adresse, 
            Datum/Uhrzeit, abgerufene URL, Referer, User-Agent, Statuscode). Zweck: technische Bereitstellung, 
            Stabilität, Fehleranalyse, IT-Sicherheit. Speicherung i. d. R. 7–14 Tage, anschließend Löschung/Anonymisierung. 
            Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <p>
            Website-Hosting und E-Mail-Versand erfolgen über in der EU ansässige Dienstleister (u. a. SMTP-Versand 
            via IONOS). Mit diesen bestehen Auftragsverarbeitungsverträge (Art. 28 DSGVO).
          </p>

          <h2>Cookies & lokale Speicherung</h2>
          <p>
            Wir verwenden nur technisch notwendige Cookies/Storage (z. B. Session-Cookie für Formulare, lokale 
            Einstellung zum Ausblenden von Hinweisen). Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO i. V. m. 
            § 25 Abs. 2 Nr. 2 TTDSG. Analyse-/Marketing-Cookies setzen wir derzeit nicht ein.
          </p>

          <h2>Kontakt- & Buchungsanfragen über die Website</h2>
          <p>
            Bei Nutzung unserer Formulare verarbeiten wir die eingegebenen Daten (z. B. Name, Kontaktdaten, 
            Adresse, Reise-/Aufenthaltsdaten, optional Bemerkungen) zur Bearbeitung der Anfrage, Kommunikation 
            und ggf. Reservierung/Vertragsdurchführung.
          </p>
          <ul>
            <li><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO; hilfsweise Art. 6 Abs. 1 lit. f DSGVO</li>
            <li><strong>Empfänger:</strong> interne Stellen; IT-/E-Mail-/Hosting-Dienstleister als Auftragsverarbeiter</li>
            <li><strong>Speicherdauer:</strong> bis Abschluss der Bearbeitung; bei Buchung gem. gesetzlichen Aufbewahrungspflichten (i. d. R. 6–10 Jahre)</li>
          </ul>

          <h2>Hotelmeldepflicht (Meldeschein, § 29 ff. Bundesmeldegesetz – BMG)</h2>
          <p>
            Als Beherbergungsstätte sind wir gesetzlich verpflichtet, von ankommenden Gästen Daten zu erheben und 
            im Meldeschein zu erfassen. Dies kann in Papier- oder digitaler Form erfolgen.
          </p>
          <ul>
            <li>
              <strong>Pflichtangaben gemäß BMG:</strong> Name, Anschrift, Geburtsdatum, Staatsangehörigkeit, 
              Ankunft/Abreise, Anzahl weiterer Mitreisender, Seriennummer des anerkannten Pass-/Ausweisdokuments 
              (bei ausländischen Gästen), Unterschrift des Gastes. Bei Geschäftsreisen bestimmter Gruppen können 
              Erleichterungen gelten.
            </li>
            <li>
              <strong>Zwecke/Rechtsgrundlage:</strong> Erfüllung einer rechtlichen Verpflichtung 
              (Art. 6 Abs. 1 lit. c DSGVO i. V. m. §§ 29–31 BMG).
            </li>
            <li>
              <strong>Aufbewahrung:</strong> Meldescheine werden gesetzlich vorgeschrieben <strong>1 Jahr</strong> 
              aufbewahrt und anschließend vernichtet/gelöscht.
            </li>
            <li>
              <strong>Vorlagepflicht:</strong> Meldescheine sind auf Anforderung den zuständigen Behörden 
              (z. B. Polizei/Meldebehörde) vorzulegen.
            </li>
          </ul>

          <h2>Zahlungen (Bar, EC-/Kreditkarte)</h2>
          <p>
            Zahlungen können vor Ort bar oder per EC-/Kreditkarte erfolgen. Bei Kartenzahlung werden Zahlungs- 
            und Transaktionsdaten durch den eingesetzten Zahlungsdienstleister verarbeitet (z. B. Autorisierung, 
            Abrechnung, Betrugsprävention). Wir erhalten hierbei nur die für den Zahlungsabgleich erforderlichen 
            Informationen.
          </p>
          <ul>
            <li><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).</li>
            <li>
              <strong>Aufbewahrung (Rechnungs-/Buchungsdaten):</strong> gem. Handels- und Steuerrecht bis zu 
              <strong> 10 Jahre</strong> (Art. 6 Abs. 1 lit. c DSGVO i. V. m. § 147 AO, § 257 HGB).
            </li>
          </ul>

          <h2>WLAN-Gastnetz</h2>
          <p>
            Wir stellen ein WLAN-Gastnetz zur Verfügung. Bei Nutzung können aus technischen Gründen Verbindungs- 
            und Nutzungsdaten (z. B. MAC-/IP-Adresse, Zeitpunkte, verbundene Geräte) verarbeitet werden. Diese Daten 
            werden nur zur Bereitstellung, Störungsbeseitigung und Sicherheit erhoben und grundsätzlich kurzfristig 
            gelöscht, sofern keine längere Speicherung zur Abwehr von Missbrauch erforderlich ist.
          </p>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (Betrieb/Sicherheit des Netzes).</p>

          <h2>Karten (OpenStreetMap via Leaflet)</h2>
          <p>
            Beim Laden der Kartenkacheln werden technische Daten (u. a. IP-Adresse, Browser-Info) an Server der 
            OpenStreetMap-Foundation (OSMF) übertragen.
          </p>
          <p>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (interessengerechte Darstellung unseres Standorts).
          </p>
          <p>
            Weitere Infos:{' '}
            <a href="https://wiki.osmfoundation.org/wiki/Privacy_Policy" target="_blank" rel="noopener noreferrer">
              OSMF-Privacy-Policy
            </a>
          </p>

          <h2>Videoüberwachung</h2>
          <p>
            Eine Videoüberwachung findet in den öffentlich zugänglichen Bereichen unseres Gästehauses derzeit 
            <strong> nicht</strong> statt. Sollte eine Überwachung zukünftig eingesetzt werden, erfolgt eine klare 
            Kennzeichnung vor Ort; Verarbeitung dann auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (Wahrnehmung des 
            Hausrechts/Schutz von Personen und Eigentum) mit angemessenen Löschfristen.
          </p>

          <h2>Empfänger, Auftragsverarbeiter, Drittlandübermittlungen</h2>
          <p>
            Eine Weitergabe erfolgt nur, soweit erforderlich oder gesetzlich vorgeschrieben: interne Stellen, 
            Steuerberatung, Zahlungsdienstleister, Behörden (z. B. nach BMG), IT-/Hosting-/E-Mail-Dienstleister 
            im Rahmen der Auftragsverarbeitung (Art. 28 DSGVO). Eine Übermittlung in Drittländer findet nicht statt 
            oder nur unter Einhaltung der Art. 44 ff. DSGVO (z. B. EU-Standardvertragsklauseln).
          </p>

          <h2>Betroffenenrechte</h2>
          <p>
            Sie haben Rechte auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung 
            (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch gegen Verarbeitungen auf Grundlage von 
            Art. 6 Abs. 1 lit. e/f (Art. 21 DSGVO). Soweit eine Verarbeitung auf Ihrer Einwilligung beruht, 
            können Sie diese jederzeit mit Wirkung für die Zukunft widerrufen (Art. 7 Abs. 3 DSGVO).
          </p>
          <p>
            Zur Ausübung genügt eine Nachricht an{' '}
            <a href="mailto:buchung@seeschlosshotel-kellersee.com">buchung@seeschlosshotel-kellersee.com</a> oder 
            die im <a href="/impressum">Impressum</a> genannten Kontaktmöglichkeiten.
          </p>
          <p>
            Sie können sich zudem bei einer Datenschutz-Aufsichtsbehörde beschweren, z. B. beim Unabhängigen 
            Landeszentrum für Datenschutz Schleswig-Holstein (ULD).
          </p>

          <h2>Speicherdauer & Löschung</h2>
          <p>
            Wir verarbeiten personenbezogene Daten nur so lange, wie es für die genannten Zwecke erforderlich ist 
            oder gesetzliche Aufbewahrungspflichten bestehen (z. B. Rechnungs-/Buchungsunterlagen bis zu 10 Jahre; 
            Meldescheine 1 Jahr). Danach werden Daten gelöscht oder anonymisiert.
          </p>

          <h2>Datensicherheit</h2>
          <p>
            Wir treffen angemessene technische und organisatorische Maßnahmen zum Schutz Ihrer Daten (u. a. 
            TLS-Verschlüsselung/HTTPS, Zugriffsbeschränkungen, Backups, Protokollierung, Prinzip der Datenminimierung).
          </p>

          <h2>Änderungen dieser Hinweise</h2>
          <p>
            Wir aktualisieren diese Datenschutzhinweise, sobald Änderungen an unserer Datenverarbeitung dies erfordern. 
            Der jeweils aktuelle Stand ist auf dieser Seite abrufbar.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
